export var PageLayout = /*#__PURE__*/function (PageLayout) {
  PageLayout["Default"] = "default";
  PageLayout["Maintenance"] = "maintenance";
  return PageLayout;
}(PageLayout || {});

